export enum AdminPanelEnum {
  defaultSort = 'lastAction',
  defaultOrder = 'DESC'
}
